import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9c2bd272")

_pushScopeId("data-v-9c2bd272")
const _hoisted_1 = { class: "success" }
const _hoisted_2 = {
  key: 0,
  class: "thumbnail"
}
const _hoisted_3 = {
  key: 1,
  class: "video"
}
const _hoisted_4 = { class: "heading-title" }
const _hoisted_5 = { class: "socials" }
const _hoisted_6 = { class: "fb-inst-icon-holder" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProgressIndicator = _resolveComponent("ProgressIndicator")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_YoutubeVideo = _resolveComponent("YoutubeVideo")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PoweredBy = _resolveComponent("PoweredBy")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_ProgressIndicator, {
          currentStep: 4,
          steps: 4
        })
      ]),
      _: 1
    }),
    (!_ctx.isVideo)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("img", { src: _ctx.imageURL }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isVideo)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_YoutubeVideo, { src: _ctx.videoURL }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode("span", null, _toDisplayString(_ctx.$t('success.heading')), 1)
    ]),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          class: "full-width large",
          onClick: _ctx.clickOpenAppMethod
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('success.openApp')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('success.socials')), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, null, {
      default: _withId(() => [
        _createVNode("div", _hoisted_6, [
          _createVNode("img", {
            src: _ctx.facebook,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickFbMethod && _ctx.clickFbMethod(...args)))
          }, null, 8, ["src"]),
          _createVNode("img", {
            src: _ctx.instagram,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickInstMethod && _ctx.clickInstMethod(...args)))
          }, null, 8, ["src"]),
          _createVNode("img", {
            src: _ctx.tiktok,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickTikTokMethod && _ctx.clickTikTokMethod(...args)))
          }, null, 8, ["src"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_PoweredBy)
      ]),
      _: 1
    })
  ]))
})